import { Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DataStateChangeEvent, GridComponent } from '@progress/kendo-angular-grid';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { CommonService } from 'src/app-core/services/common.service';
import { ContactFormDialogComponent } from '../add-contact/contact-form-dialog/contact-form-dialog.component';
import { AppComponentBase } from '../app-component-base';
import { CommonDataModel } from '../common-data-model';
import { CommonConstants } from 'src/app-core/constants/common-constants';

@Component({
    selector: 'app-contact-list',
    templateUrl: './contact-list.component.html',
    styleUrls: ['./contact-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class ContactListComponent extends AppComponentBase implements OnInit {

    @ViewChild('grid', { static: true }) private grid: GridComponent;
    @Input() set accountDetails(accountDetails: any) {
        if (accountDetails) {
            this.statusValue = `${accountDetails.activeStatus}`;
            this.accountInformation = accountDetails;
            this.onRefreshGridData();
        }
    }
    @Input() accountName: string;
    @Output() getCount: EventEmitter<number> = new EventEmitter<number>();
    @Output() onEmitEditContact: EventEmitter<any> = new EventEmitter<any>();
    @Output() onCloseDialog: EventEmitter<any> = new EventEmitter<any>();
    commonDataModel = new CommonDataModel();
    contactStatusModel = this.commonDataModel.contactStatusModel;
    searchQuery: string;
    rowSelectionList: number[] = [];
    statusValue = 'true';
    accountInformation: any;
    isOnOrderOverview = false;

    constructor(
        injector: Injector,
        public dialog: MatDialog,
        private router: Router,
        private toastr: ToastrService,
        private commonService: CommonService) {
        super(injector);
    }

    ngOnInit(): void {
        if (this.router.url.indexOf('app/quotes/quote-details') !== -1 || this.router.url.indexOf('app/jobs/job-details') !== -1) {
            this.isOnOrderOverview = true;
        } else {
            this.isOnOrderOverview = false;
        }
        this.statusValue = `${this.accountInformation.activeStatus}`;
        this.kendogridHelper.sort = [{ dir: 'asc', field: 'contactType' }];
        this.onRefreshGridData();
    }

    onRefreshGridData(): void {
        this.kendogridHelper.defaultRecordsCountPerPage = 10;
        this.grid.dataStateChange.emit({
            skip: 0,
            take: this.kendogridHelper.defaultRecordsCountPerPage,
            filter: undefined,
            group: undefined,
            sort: this.kendogridHelper.sort,
        });
    }

    getGridList(event: DataStateChangeEvent): void {
        if (event) {
            this.kendogridHelper.dataStateChangeEvent(event);
        }
        this.kendogridHelper.showLoadingIndicator();
        const queryParams = this.accountInformation.accountId ? `&AccountId=${this.accountInformation.accountId}` : '';
        const gridStatus = `&IsActive=${this.statusValue}`;
        this.commonService.getContactGridRecords(event, queryParams, gridStatus)
            .pipe(finalize(() => (this.kendogridHelper.hideLoadingIndicator()))).subscribe(response => {
                this.kendogridHelper.setGridData(response.data);
                this.getCount.emit(this.kendogridHelper.totalRecordsCount);
                this.kendogridHelper.hideLoadingIndicator();
            });
    }

    onViewDetail(dataItem: any): void {
        if (this.isOnOrderOverview) {
            this.onEmitEditContact.emit(dataItem);
        } else {
            this.onCloseDialog.emit(false);
            this.router.navigate(['app/contacts/contact-details', dataItem.contactId]);
        }
    }

    onOpenDialog(): void {
        const dialogRef = this.dialog.open(ContactFormDialogComponent, {
            position: {
                right: '0',
            },
            panelClass: 'small_layout',
            hasBackdrop: false,
            data: { contactId: null, isEdit: false, accountTypeId: this.accountInformation.accountTypeId, accountId: this.accountInformation.id, accountName: this.accountInformation.accountName },
        }).afterClosed()
            .subscribe((response: any) => {
                if (response && (response.confirmResult || response.data.confirmResult)) {
                    this.onRefreshGridData();
                } else {
                    this.getCount.emit(this.kendogridHelper.totalRecordsCount);
                }
            });
    }

    onChangeStatus(dataItem: any) {
        if (dataItem.contactType === 'Primary') {
            this.toastr.warning(CommonConstants.contactListConstants.primaryContactWarning);
            this.onRefreshGridData();
        } else {
            this.commonService.getConfirmationPopup
                (`You want to ${this.statusValue === 'true' ? 'delete' : 'activate'} Contact Id: <b>${dataItem.contactDisplayId}</b> and Contact Name: <b>${dataItem.contactName}</b>`,
                    'Cancel', 'Confirm').then(result => {
                        if (result) {
                            this.commonService.objectMapping(this.contactStatusModel, dataItem);
                            this.kendogridHelper.showLoadingIndicator();
                            this.commonService.updateContactStatus(this.contactStatusModel)
                                .pipe(finalize(() => this.kendogridHelper.hideLoadingIndicator()))
                                .subscribe(response => {
                                    this.toastr.success(dataItem.isActive ? CommonConstants.contactListConstants.contactActivatedMessage : CommonConstants.contactListConstants.contactDeactivatedMessage);
                                    this.onRefreshGridData();
                                });
                        } else {
                            dataItem.isActive = !dataItem.isActive;
                        }
                    });
        }
    }

    onToggleChange(value: string) {
        this.statusValue = value;
        this.onRefreshGridData();
    }

}
